/* eslint-disable import/prefer-default-export */

export const getFullPathFolder = (folder, rootFolder, dialogs) => {
  if (!folder) return '';

  let path = `${rootFolder}`;
  const { parent } = folder;

  if (parent) {
    let middlePath = null;
    const getAn = (currentParent) => {
      if (currentParent && currentParent.parent) {
        getAn(dialogs[currentParent.parent]);
      }

      middlePath = !middlePath ? currentParent.title : `${middlePath} › ${currentParent.title}`;
    };
    getAn(dialogs[parent]);

    path = `${path} › ${middlePath || dialogs[parent].untitlePlaceholder}`;
  }

  return `${path} › ${folder.title || folder.untitlePlaceholder}`;
};
